import {fieldOptionsConstants} from "@/constants/CustomerFormatFieldOptions";

export const detailTypes = {
    OPTIONS: 'options',
    PLACEHOLDER: 'placeholder',
    DEFAULT_VALUE: 'default_value',
    DEFAULT_STATUS: 'default_status',
    DISABLE: 'disable',
}


export const detailTypesFarsi = {
    OPTIONS: 'گزینه‌ها (options)',
    PLACEHOLDER: 'متن نمایشی (placeholder)',
    DEFAULT_VALUE: 'مقدار پیش‌فرض',
    DEFAULT_STATUS: 'وضعیت پیش‌فرض (حالت اولیه)',
    DISABLE: 'غیرفعال بودن فیلد',

    get(type) {
        let type_str = null;

        Object.keys(detailTypes).forEach(item => {
            if (detailTypes[item] === type) {
                type_str = detailTypesFarsi[item];
            }
        });

        return type_str;
    }
}

export const detailDataVariant = (type, data) => {
    switch (type) {
        case detailTypes.OPTIONS:
        case detailTypes.PLACEHOLDER:
        case detailTypes.DEFAULT_VALUE:
            return data
        case detailTypes.DEFAULT_STATUS:
            return fieldOptionsConstants.get(data)
        case detailTypes.DISABLE:
            return data === true ? 'فعال' : 'غیرفعال'
        default:
            return data
    }
}